import { render, staticRenderFns } from "./ElectricCar.vue?vue&type=template&id=4f189982"
import script from "./ElectricCar.vue?vue&type=script&lang=js"
export * from "./ElectricCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports